import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrDarkModal from 'client/components/SrDarkModal';
import './SrModalSplitView.less';

const SrModalSplitView = ({
  leftChild,
  rightChild,
  onClose,
}) => {

  return (
    <SrDarkModal>
      <SrBox styleName='SrModalSplitView'>
        <SrBox styleName='leftChildContainer'>
          <SrBox margin='40px'>
            <img
              onClick={onClose}
              src='/images/circle-x-icon-white.svg'
              alt='close-icon'
              styleName='closeButton'
            />
            {leftChild}
          </SrBox>
        </SrBox>
        <SrBox styleName='rightChildContainer'>
          {rightChild}
        </SrBox>
      </SrBox>
    </SrDarkModal>
  );
};

SrModalSplitView.propTypes = {
  leftChild: PropTypes.node.isRequired,
  rightChild: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrModalSplitView.displayName = 'SrModalSplitView';

export default SrModalSplitView;
